var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraProviders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.2,
    viewBox: "0 0 18 16.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "camera-svgrepo-com",
    d: "M9,19.2h4c2.809,0,4.213,0,5.222-.662a3.967,3.967,0,0,0,1.1-1.084c.674-.991.674-2.37.674-5.127S20,8.19,19.326,7.2a3.966,3.966,0,0,0-1.1-1.084,5.176,5.176,0,0,0-2.7-.632A1.265,1.265,0,0,1,14.3,4.473,1.858,1.858,0,0,0,12.47,3H9.53A1.858,1.858,0,0,0,7.7,4.473,1.265,1.265,0,0,1,6.48,5.485a5.175,5.175,0,0,0-2.7.632A3.964,3.964,0,0,0,2.674,7.2C2,8.19,2,9.569,2,12.327s0,4.137.674,5.127a3.966,3.966,0,0,0,1.1,1.084C4.787,19.2,6.191,19.2,9,19.2ZM11,8.645a3.682,3.682,0,1,0,3.75,3.682A3.716,3.716,0,0,0,11,8.645Zm0,1.473a2.209,2.209,0,1,0,2.25,2.209A2.23,2.23,0,0,0,11,10.118Zm4.25-.736A.743.743,0,0,1,16,8.645h1a.736.736,0,1,1,0,1.473H16A.743.743,0,0,1,15.25,9.382Z",
    transform: "translate(-2 -3)",
    fill: "#5a5a5a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraProviders);
export default __webpack_public_path__ + "static/media/camera_providers.fbd5a529686ecd2bb29e5d47b84e4bf8.svg";
export { ForwardRef as ReactComponent };